import { t } from "@lingui/macro";
import { Form, FormInstance, Input, InputNumber, Space, Switch } from "antd";
import { FC, useState } from "react";
import { useParams } from "react-router-dom";
import { formatDateTimeString } from "utils/format";
import { SubscriptionPackage } from "../type";

interface OtherInformationProps {
	form: FormInstance<SubscriptionPackage>;
}
const OtherInformation: FC<OtherInformationProps> = ({ form }) => {
	const { id } = useParams();
	const updatedBy = form.getFieldValue(["updatedBy", "fullName"]);
	return (
		<div className="shadow-lg px-5 pt-5 pb-10 bg-white p-5 w-full">
			<div className="mt-3 flex justify-between mb-4">
				<label className="font-semibold text-lg">{t`Other information`}</label>
			</div>
			<div className="w-full space-y-5">
				<Space className="w-1/2" direction="vertical">
					<p className="w-40">{t`Best seller`}</p>
					<Form.Item
						name="isBestSeller"
						valuePropName="checked"
						label={t`Best seller`}
					>
						<Switch
							checkedChildren={t`Enable`}
							unCheckedChildren={t`Disable`}
						/>
					</Form.Item>

					<p className="w-full">{t`Order`}</p>
					<Form.Item name="ordinal" label={t`Order`} className="w-full">
						<InputNumber />
					</Form.Item>
					{id && (
						<>
							<p className="w-40">{t`Updated date`}</p>
							<Form.Item name="updatedAt" label={t`Updated date`}>
								{formatDateTimeString(form.getFieldValue("updatedAt"))}
							</Form.Item>
						</>
					)}
				</Space>

				<Space className="w-1/2" direction="vertical">
					<p className="w-40">{t`Status`}</p>
					<Form.Item name="isEnabled" valuePropName="checked" label={t`Status`}>
						<Switch
							checkedChildren={t`Enable`}
							unCheckedChildren={t`Disable`}
						/>
					</Form.Item>
					{id && (
						<>
							<p className="w-40">{t`Updated by`}</p>
							<Input disabled value={updatedBy} />
							<p className="w-40">{t`Created date`}</p>
							<Form.Item name="updatedAt" label={t`Created date`}>
								{formatDateTimeString(form.getFieldValue("createdAt"))}
							</Form.Item>
						</>
					)}
				</Space>
			</div>
		</div>
	);
};

export default OtherInformation;
